import styled from "styled-components";

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 40px;
  padding-bottom: 0px;
  margin-top: 40px;

  @media (max-width: 767px) {
     padding: 20px 20px;
     padding-bottom: 0px;
     margin-top: 0;
  }
`;

export const Header = styled.h2`
  font-size: 48px;
  color: #252525;
  text-align: center;
  margin: 20px 0;

        @media (max-width: 767px) {
     font-size: 32px;
  }

  &.mobile-header {
    display: block;

    @media (min-width: 992px) {
      display: none;
    }
  }

  &.desktop-header {
    display: none;

    @media (min-width: 992px) {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.4);
      color: white;
      padding: 40px;
      font-size: 48px;
      margin: 0;
      z-index: 2;
      display: block;
      backdrop-filter: blur(3px);
    }
  }
`;

export const DescriptionSection = styled.div`
  order: 2;
`;

export const ImageWrapper = styled.div`
  margin-bottom: 0;
  position: relative;
  width: 100%;
  order: 3;
  height: 300px;


  @media (min-width: 992px) {
    order: 1;
    background-image: url(${(props) => props.$imageSrc});
    background-size: cover;
    background-position: center;
    background-attachment: fixed;
    height: 500px;
    width: 100vw;
    margin-bottom: 25px;
  }
`;

export const Image = styled.img`
  width: 100%;
  height: 100%; 
  display: block;
  object-fit: cover;

    @media (min-width: 992px) {
    display: none;
  }
`;